module.exports = __webpack_public_path__ + "static/logo.93b0dd72.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo.png
// module id = 583
// module chunks = 114276838955818